<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">提出对文件的质疑</h2>
            </div>
            <div class="header-action">
                
                <el-button type="primary" icon="el-icon-plus" @click="handleAddQuestion">添加问题</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 表格内容 -->
        <div class="content-container">
            <el-table :data="tableData" border style="width: 100%" class="question-table">
                <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="complaintCode" label="问题编码" min-width="150"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidSectionName" label="标段名称" min-width="180"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="问题标题" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="submitTime" label="问题提交时间" width="180" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleViewDetail(scope.row)" class="view-btn">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>


            <!-- 分页 -->
            <div class="pagination-container" v-if="tableData.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>

            <ComplainDialog :visible.sync="complainDialogVisible" :project-code="projectCode"
                :bid-section-code="bidSectionCode" :bid-section-name="bidSectionName" :complaint-type="complaintType"
                :edit-data="editData" @save="handleComplainSave" @close="handleComplainClose"
                :file-bind-id="fileGuid" />

            <!-- 详情弹窗 -->
            <el-dialog title="问题详情" :visible.sync="detailDialogVisible" width="800px" :append-to-body="true">
                <div class="detail-content">
                    <!-- 基本信息 -->
                    <div class="detail-section">
                        <h4>基本信息</h4>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>项目编号：</label>
                                    <span>{{ detailData.projectCode }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>标段编号：</label>
                                    <span>{{ detailData.bidSectionCode }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>标段名称：</label>
                                    <span>{{ detailData.bidSectionName }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>投诉类型：</label>
                                    <span>{{ getComplaintTypeText(detailData.complaintType) }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>问题编码：</label>
                                    <span>{{ detailData.complaintCode }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>提交时间：</label>
                                    <span>{{ detailData.submitTime }}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div class="detail-item">
                                    <label>标题：</label>
                                    <span>{{ detailData.title }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 依据 -->
                    <div class="detail-section">
                        <h4>依据</h4>
                        <div class="content-box">
                            {{ detailData.accordingTo || '无' }}
                        </div>
                    </div>

                    <!-- 问题内容 -->
                    <div class="detail-section">
                        <h4>问题内容</h4>
                        <div class="content-box">
                            {{ detailData.content }}
                        </div>
                    </div>

                    <!-- 备注 -->
                    <div class="detail-section" v-if="detailData.remark">
                        <h4>备注</h4>
                        <div class="content-box">
                            {{ detailData.remark }}
                        </div>
                    </div>

                    <!-- 提交人信息 -->
                    <div class="detail-section">
                        <h4>提交人信息</h4>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="detail-item">
                                    <label>提交单位名称：</label>
                                    <span>{{ detailData.submitUserName }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="detail-item">
                                    <label>联系人：</label>
                                    <span>{{ detailData.submitContact }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="detail-item">
                                    <label>联系电话：</label>
                                    <span>{{ detailData.submitPhone }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 附件列表 -->
                    <div class="detail-section" v-if="fileListData.length > 0">
                        <h4>相关附件</h4>
                        <el-table :data="fileListData" border style="width: 100%">
                            <el-table-column prop="fileName" label="文件名" min-width="200"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="fileExtension" label="文件类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small">{{ scope.row.fileExtension.toUpperCase() }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                                <template slot-scope="scope">
                                    {{ formatFileSize(scope.row.fileSize) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="downloadFile(scope.row)"
                                        class="download-btn">下载</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- 回复内容 -->
                    <div class="detail-section" v-if="detailData.replyContent">
                        <h4>回复内容</h4>
                        <div class="content-box">
                            {{ detailData.replyContent }}
                        </div>
                        <el-row :gutter="20" style="margin-top: 10px;">
                            <el-col :span="8">
                                <div class="detail-item">
                                    <label>回复人：</label>
                                    <span>{{ detailData.replyUserName }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="detail-item">
                                    <label>回复联系人：</label>
                                    <span>{{ detailData.replyContact }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="detail-item">
                                    <label>回复时间：</label>
                                    <span>{{ detailData.replyTime }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 回复附件列表 -->
                    <div class="detail-section" v-if="replyFileListData.length > 0">
                        <h4>回复附件</h4>
                        <el-table :data="replyFileListData" border style="width: 100%">
                            <el-table-column prop="fileName" label="文件名" min-width="200"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="fileExtension" label="文件类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small">{{ scope.row.fileExtension.toUpperCase() }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                                <template slot-scope="scope">
                                    {{ formatFileSize(scope.row.fileSize) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="downloadFile(scope.row)"
                                        class="download-btn">下载</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import ComplainDialog from '@/components/common/complainDialog.vue'
import { getBidSectionInfo } from '@/api/modules/bidEvaluationCommittee'
import { getComplainList, getComplainDetail,getComplainBidderList } from '@/api/modules/createComplain'
import { getFileList,getInfoBySectionCode } from '@/api/modules/base'
export default {
    name: 'RaiseAQuestion',
    components: {
        ComplainDialog
    },
    data() {
        return {
            fileGuid: '',
            projectTitle: '',
            sectionCode: this.$route.query.sectionCode || '',   // 获取项目编号
            projectCode: this.$route.query.projectCode,

            sectionInfo: {},
            tableData: [
            ],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            complainDialogVisible: false,
            projectCode: '',
            bidSectionCode: '',
            bidSectionName: '标段名称',
            complaintType: 'bidDoc',
            editData: {},
            detailDialogVisible: false,
            detailData: {},
            fileListData: [],
            replyFileListData: [],
            bidOpeningTime: null  // 开标时间
        }
    },
    mounted() {
        this.getProjectInfo()
        this.initFileGuid()
        this.getInfoBySectionCode()
    },
    methods: {
     


        // 初始化文件关联标识
        initFileGuid() {
            this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        },
        //根据标段编号获取文件信息

       async getInfoBySectionCode(){
             const res = await getInfoBySectionCode(this.sectionCode)
             if(res.code==200){
                 this.bidOpeningTime = res.data.bidOpeningTime
             }else{
                 this.$message.error(res.msg)
             }
        },

        // 获取项目信息
        async getProjectInfo() {
            const res = await getBidSectionInfo(this.sectionCode)
            this.sectionInfo = res.data
            this.projectTitle = `投标人流程——招标项目编号：${this.sectionInfo.projectCode || ''}　招标项目名称：${this.sectionInfo.projectName || ''}`
            this.projectCode = this.sectionInfo.projectCode;
            this.bidSectionCode = this.sectionInfo.bidSectionCode;
            this.bidSectionName = this.sectionInfo.bidSectionName;
            this.getComplainList()

        },
        //  获取列表
        async getComplainList() {
            let data = {
                complaintType: this.complaintType,
                projectCode: this.projectCode,
                bidSectionCode:this.sectionCode,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                stage: 0
            }
            const res = await getComplainBidderList(this.complaintType, data);
            if (res.code === 200) {
                console.log('-----获取列表');
                console.log(res);
                console.log('-----获取列表');
                
                this.tableData = res.data.records;
                this.total = res.data.total;
            } else {
                this.$message.error(res.msg)
            }
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 添加问题
        handleAddQuestion() {
            // 验证开标时间
            if (this.bidOpeningTime) {
                const currentTime = new Date().getTime()
                const openingTime = new Date(this.bidOpeningTime).getTime()
                if (currentTime >= openingTime) {
                    this.$message.warning('质疑时间已过')
                    return
                }
            }
            this.complainDialogVisible = true;
        },
        // 查看详细信息
        handleViewDetail(row) {
            this.getComplainDetail(row)
        },
        //  查看详情
        async getComplainDetail(row) {
            const res = await getComplainDetail(row.complaintType, { complaintCode: row.complaintCode });
            if (res.code === 200) {
                this.detailData = res.data;
                // 获取问题附件
                if (res.data.submitFileGuid) {
                    await this.getFileList(res.data.submitFileGuid, 'submit');
                }
                // 获取回复附件
                if (res.data.replyFileGuid) {
                    await this.getFileList(res.data.replyFileGuid, 'reply');
                }
                // 打开详情弹窗
                this.detailDialogVisible = true;
            }
        },
        //  获取附件列表
        async getFileList(fileGuid, type = 'submit') {
            try {
                const res = await getFileList(fileGuid);
                if (res.code === 200) {
                    if (type === 'submit') {
                        this.fileListData = res.data || [];
                    } else if (type === 'reply') {
                        this.replyFileListData = res.data || [];
                    }
                }
            } catch (error) {
                console.error('获取附件列表失败:', error);
            }
        },
        // 格式化文件大小
        formatFileSize(size) {
            if (size < 1024) {
                return size + ' B';
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(1) + ' KB';
            } else {
                return (size / (1024 * 1024)).toFixed(1) + ' MB';
            }
        },
        // 下载文件
        downloadFile(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank');
            } else {
                this.$message.error('文件链接不存在');
            }
        },
        // 获取投诉类型文字
        getComplaintTypeText(type) {
            const typeMap = {
                'bidDoc': '对文件的质疑',
                'bidResult': '对评标结果投诉',
                'bidOpen': '对开标过程质疑'
            }
            return typeMap[type] || type || '未知'
        },
        // 获取状态标签类型
        getStatusType(status) {
            const statusMap = {
                0: 'warning',
                1: 'success',
                2: 'info'
            }
            return statusMap[status] || 'info'
        },
        // 获取状态标签文字
        getStatusText(status) {
            const statusMap = {
                0: '暂存',
                1: '已提交',
                2: '已答复'
            }
            return statusMap[status] || '未知状态'
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.pageNum = 1
            this.getComplainList()
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.pageNum = val
            this.getComplainList()
        },
        // 处理投诉保存
        handleComplainSave(formData) {
            this.complainDialogVisible = false
            this.$message.success(formData.status === 0 ? '暂存成功' : '提交成功')
        },

        // 处理投诉弹窗关闭
        handleComplainClose() {
            this.complainDialogVisible = false
            this.getComplainList()
        }
    },

}
</script>

<style lang="less" scoped>
/* 详情弹窗样式 */
.detail-content {
    .detail-section {
        margin-bottom: 24px;

        h4 {
            margin: 0 0 12px 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
            border-left: 4px solid #409eff;
            padding-left: 12px;
        }

        .detail-item {
            margin-bottom: 8px;

            label {
                font-weight: 500;
                color: #606266;
                margin-right: 8px;
            }

            span {
                color: #333;
            }
        }

        .content-box {
            background: #f5f7fa;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            padding: 16px;
            color: #333;
            line-height: 1.6;
            min-height: 80px;
            white-space: pre-wrap;
        }
    }

    .el-table {
        .download-btn {
            color: #409eff;

            &:hover {
                color: #66b1ff;
            }
        }
    }
}

.dialog-footer {
    text-align: center;
}
</style>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
    display: flex;
    gap: 10px;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.question-table {
    border-radius: 4px;
    overflow: hidden;

    /deep/ th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600;
        border-color: @gray-200 !important;
    }

    /deep/ td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.view-btn {
    color: @gray-600;

    &:hover {
        color: @primary-color;
    }
}

.detail-content {
    padding: 20px;

    .detail-section {
        margin-bottom: 24px;

        &:last-child {
            margin-bottom: 0;
        }

        h4 {
            color: @gray-700;
            font-size: 16px;
            font-weight: 600;
            margin: 0 0 16px 0;
            padding-bottom: 10px;
            border-bottom: 1px solid @gray-200;
        }
    }

    .detail-item {
        display: flex;
        margin-bottom: 12px;

        label {
            color: @gray-600;
            font-weight: 500;
            min-width: 100px;
        }

        span {
            color: @gray-700;
            flex: 1;
        }
    }

    .content-box {
        padding: 16px;
        background: @gray-50;
        border: 1px solid @gray-200;
        border-radius: 6px;
        color: @gray-700;
        line-height: 1.6;
    }
}

.download-btn {
    color: @gray-600;

    &:hover {
        color: @primary-color;
    }
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
        flex-direction: column;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }
}

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
    font-size: 15px;
}

.content-wrap {
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: white;
}

.question-table {
    .el-table__header {
        background-color: #f5f7fa;
    }

    .el-table__header th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
    }

    .view-btn {
        color: #409EFF;
        font-weight: 500;

        &:hover {
            color: #66b1ff;
        }
    }
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}
</style>